import styled from 'styled-components';
import { Button } from '@perch-labs/shrike';

export const StyledButton = styled(Button).attrs({
  fullWidth: true,
  margin: { top: '40px' },
})`
  max-width: 320px;
`;
